import { defineStore } from 'pinia';
import { scriptLoader } from '~/utils/scriptLoader';

export const useStoreMatch2One = defineStore('match2one', {
  actions: {
    async loadUniversalScript() {
      try {
        await scriptLoader('https://acdn.adnxs.com/dmp/up/pixie.js', 'match2one');

        // @ts-ignore
        pixie('init', 'da782146-c4a3-4ff3-a4eb-3082a89147aa');

        setTimeout(() => {
          this.trigger('PageView');
        }, 1000);
      } catch (e) {
        console.error(e);
      }
    },
    trigger(eventName: string, payload?: Record<string, any>) {
      if (!payload) {
        // @ts-ignore
        pixie('event', eventName);
        console.log('PIXIE TRIGGER: ', eventName);
      } else {
        // @ts-ignore
        pixie('event', eventName, payload);
        console.log('PIXIE TRIGGER: ', eventName, payload);
      }
    },
  },
});
